<script>
  import Select from "svelte-select";
  import Check from "./check.svelte";
  import Cancel from "./cancel.svelte";
  import Questionmark from "./questionmark.svelte";

  export let country;
  export let revColScale;
  export let colors;

  let selectedValue = "#ffffff";

  let items = colors.map((d) => {
    let obj = {};
    obj.value = d;
    obj.label = `<span style="background-color: ${d}; padding-left: 35px; border-radius: 0px; cursor: pointer;"></span>`;
    return obj;
  });

  function handleSelect(event) {
    selectedValue = event.detail.value;
  }
</script>

<div class="picker">
  {#if selectedValue == "#ffffff"}
    <div class="icon-container question-mark">
      <Questionmark />
    </div>
  {:else if revColScale(selectedValue) == country}
    <div class="icon-container check">
      <Check />
    </div>
  {:else}
    <div class="icon-container cancel">
      <Cancel />
    </div>
  {/if}

  <div class="select-container">
    <Select
      {items}
      {selectedValue}
      on:select={handleSelect}
      placeholder={"?"}
      showIndicator={false}
      isClearable={false}
      isSearchable={false}
      inputStyles={`background-color: ${selectedValue}; border: none; cursor: pointer; border-radius: 0px`}
    />
  </div>
  <div class="country-name">{country}</div>
</div>

<style>
  :global(.picker) {
    display: flex;
  }
  :global(.select-container) {
    width: 30px;
    --height: 20px;
    --itemPadding: 1px 0px 0px 0px;
    --inputPadding: 0px;
    --selectedItemPadding: 0 0 0 0;
    --borderRadius: 0px;
    --listBorderRadius: 0px;
    --itemFirstBorderRadius: 0px;
    --listMaxHeight: 500px;
    --indicatorWidth: 0;
  }
  :global(.icon-container) {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  :global(.country-name) {
    margin-left: 12px;
  }
</style>
